import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

import {
  logChatbotConversationCreatedFromStartOver,
  logChatbotErrorMessageAppears,
  logChatbotSendMessage,
  logSearchResultsPresented,
  logSingleArticlePresented,
  logWidgetEmptySearchResults,
} from '../bi';
import { TRootState } from '../common/reducers';
import { attachesSlice } from '../common/reducers/attaches';
import { chatActions } from '../common/reducers/chat';
import { fieldActions } from '../common/reducers/field';
import { ResetReason } from '../common/reducers/types';
import { loadArticleById, loadArticleByUri } from '../common/thunks/articles.thunk';
import { loadAttaches } from '../common/thunks/attaches.thunk';
import { loadSolutions } from '../common/thunks/solutions.thunk';

export const biMiddleware = ({ getState }: MiddlewareAPI<any, TRootState>) => {
  return (next: Dispatch) => (action: AnyAction) => {
    if (loadSolutions.fulfilled.match(action)) {
      const state = getState();

      logSearchResultsPresented(state, action.payload);
      if (state.solutions.isUserTypedSearch && action.payload.length === 0) {
        logWidgetEmptySearchResults(state);
      }
    } else if (chatActions.updateSession.match(action)) {
      const state = getState();
      const {
        chat: { resetReason, conversationId },
      } = state;

      if (resetReason === ResetReason.StartOver && action.payload.conversationId !== conversationId) {
        logChatbotConversationCreatedFromStartOver(state, {
          destinationConversationId: action.payload.conversationId,
        });
      }
    } else if (attachesSlice.actions.addError.match(action) || loadAttaches.rejected.match(action)) {
      if (action.payload?.bi) {
        logChatbotErrorMessageAppears(getState(), action.payload.bi);
      }
    } else if (fieldActions.sendMessage.match(action)) {
      logChatbotSendMessage(getState());
    } else if (loadArticleById.fulfilled.match(action) || loadArticleByUri.fulfilled.match(action)) {
      const state = getState();
      logSingleArticlePresented(state, action.payload);
    }

    return next(action);
  };
};
